'use strict';

var assertion = require('./errors/assertion.cjs.js');
var common = require('./errors/common.cjs.js');
var CustomErrorBase = require('./errors/CustomErrorBase.cjs.js');
var ResponseError = require('./errors/ResponseError.cjs.js');
var error = require('./serialization/error.cjs.js');
var response = require('./serialization/response.cjs.js');



exports.assertError = assertion.assertError;
exports.isError = assertion.isError;
exports.AuthenticationError = common.AuthenticationError;
exports.ConflictError = common.ConflictError;
exports.ForwardedError = common.ForwardedError;
exports.InputError = common.InputError;
exports.NotAllowedError = common.NotAllowedError;
exports.NotFoundError = common.NotFoundError;
exports.NotImplementedError = common.NotImplementedError;
exports.NotModifiedError = common.NotModifiedError;
exports.ServiceUnavailableError = common.ServiceUnavailableError;
exports.CustomErrorBase = CustomErrorBase.CustomErrorBase;
exports.ResponseError = ResponseError.ResponseError;
exports.deserializeError = error.deserializeError;
exports.serializeError = error.serializeError;
exports.stringifyError = error.stringifyError;
exports.parseErrorResponseBody = response.parseErrorResponseBody;
//# sourceMappingURL=index.cjs.js.map
